'use client'

import React from 'react'
import Image from "next/image"
import LikeSuccessIcon from "@/public/icons/like-success-icon.svg"
import DisLikeRedIcon from "@/public/icons/dislike-red-icon.svg"
import NotSureIcon from "@/public/icons/not-sure-icon.svg"
import VoteCommentComponent from "@/components/ui/comments/vote-comment-component"
import {cn} from "@/lib/utils"
import {useDateFormatter} from "@/hook/dateFormater"
import {SingleProductEnum} from "@/constants/commerce-enum";
import {CommentTypes} from "@/types/components/comment";


export default function CommentCardComponentDesktop({
                                                        rate,
                                                        content,
                                                        username,
                                                        date,
                                                        adminResponse,
                                                        likesCount,
                                                        dislikesCount,
                                                        id
                                                    }: CommentTypes) {
    const formatDate = useDateFormatter()

    const ratingClass = cn(
        "w-[35px] h-[20px] text-white flex items-center justify-center rounded-md",
        {
            "bg-green-500": rate > 3,
            "bg-red-500": rate < 3,
            "bg-yellow-400": rate === 3
        }
    )

    return (
        <div className="w-full flex flex-col space-y-4">
            <div className="w-full flex flex-wrap content-start pb-5">
                <section className='w-full flex flex-wrap'>
                    <div className="flex grow items-start flex-wrap">
                        <div className='w-full flex items-center space-x-4 mt-7'>
                            <div className='flex-1 text-sm flex flex-wrap gap-3 items-center justify-start'>
                <span className={ratingClass}>
                  {rate.toLocaleString("fa")}
                </span>
                                <span className="text-gray-400">
                  {username}
                </span>
                                <span className="bg-gray-200 h-full w-[1px]"></span>
                                <span className="text-gray-400">{formatDate(date)}</span>
                            </div>
                        </div>

                        <div className="w-full flex items-center flex-wrap py-4 gap-2">
                            {rate > 3 && (
                                <>
                                    <Image src={LikeSuccessIcon} alt="LikeSuccessIcon" height={20} width={20}/>
                                    <h4 className='flex text-green-500 flex-wrap text-xs font-medium'>
                                        {SingleProductEnum.recommendTOBuy}</h4>
                                </>
                            )}
                            {rate < 3 && (
                                <>
                                    <Image src={DisLikeRedIcon} alt="DisLikeRedIcon" title="DisLikeRedIcon" height={20}
                                           width={20}/>
                                    <h4 className='flex text-red-500 flex-wrap text-xs font-medium'>
                                        {SingleProductEnum.notRecommendTOBuy}
                                    </h4>
                                </>
                            )}
                            {rate === 3 && (
                                <>
                                    <Image src={NotSureIcon} alt="NotSureIcon" title={"NotSureIcon"} height={20}
                                           width={20}/>
                                    <h4 className='flex text-yellow-400 flex-wrap text-xs font-medium'>
                                        {SingleProductEnum.notSure}
                                    </h4>
                                </>
                            )}
                        </div>

                        <p className='w-full text-sm font-medium flex flex-wrap'>
                            {content}
                        </p>
                    </div>
                </section>
            </div>
            <VoteCommentComponent likesCount={likesCount} id={id} dislikesCount={dislikesCount}/>
            {adminResponse && (
                <div className="bg-gray-100 p-4 rounded-lg mt-4">
                    <h5 className="font-semibold mb-2">{SingleProductEnum.adminAnswer}:</h5>
                    <p className="text-sm">{adminResponse}</p>
                </div>
            )}


        </div>
    )
}